// DH Delivery Estimator - Calculadora completa (Standard / Express / Pickup)
// - Soporta rangos estándar (prep + tránsito) y rangos retiro
// - Express con preparación 0 + cutoff + hábiles/feriados
// - Cutoff (p.ej. 12:00) afecta el "día base" de cómputo para estándar y retiro

window.__DH_REGIONS_CACHE__ = window.__DH_REGIONS_CACHE__ || null;
window.__DH_TRANSIT_CACHE__ = window.__DH_TRANSIT_CACHE__ || null;

function dhNormalize(str) {
  return (str || "")
    .toString()
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

function dhSplitCommaList(str) {
  return (str || "")
    .split(/[,;\n]+/g)
    .map((s) => s.trim())
    .filter(Boolean);
}

function dhToISODate(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

function dhIsWeekend(date) {
  const d = date.getDay(); // 0 dom, 6 sáb
  return d === 0 || d === 6;
}

function dhIsHoliday(date) {
  const iso = dhToISODate(date);
  const list = Array.isArray(window.DH_HOLIDAYS) ? window.DH_HOLIDAYS : [];
  return list.includes(iso);
}

function dhIsBusinessDay(date) {
  return !dhIsWeekend(date) && !dhIsHoliday(date);
}

function dhCloneDate(d) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds());
}

function dhStartOfDay(d) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
}

function dhAddBusinessDays(startDate, daysToAdd) {
  const result = new Date(startDate.getTime());
  let remaining = Number(daysToAdd) || 0;

  while (remaining > 0) {
    result.setDate(result.getDate() + 1);
    if (dhIsBusinessDay(result)) remaining -= 1;
  }
  return result;
}

function dhNextBusinessDay(date) {
  const d = new Date(date.getTime());
  do {
    d.setDate(d.getDate() + 1);
  } while (!dhIsBusinessDay(d));
  return d;
}

function dhFormatDateShort(date) {
  const weekdays = ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"];
  const dayName = weekdays[date.getDay()];
  const dayNum = date.getDate();
  return `${dayName} ${dayNum}`;
}
function dhNormalizeSpaces(str) {
  return (str || "").toString().trim().replace(/\s+/g, " ");
}

function dhGetPickupPrefixes(pickupResultLabel) {
  const label = dhNormalizeSpaces(pickupResultLabel || "Retira entre");
  const single = label.replace(/\s+entre$/i, "");
  return {
    rangePrefix: label,                 // "Retira entre"
    singlePrefix: single || label       // "Retira"
  };
}

function dhComputeRangeLabelFromBaseWithPrefixes(baseDate, minDays, maxDays, rangePrefix, singlePrefix) {
  const minN = Math.max(0, Number(minDays) || 0);
  const maxN = Math.max(0, Number(maxDays) || 0);

  const from = dhAddBusinessDays(baseDate, minN);
  const to = dhAddBusinessDays(baseDate, maxN);

  if (minN === maxN) return `${singlePrefix} ${dhFormatDateShort(from)}`;
  return `${rangePrefix} ${dhFormatDateShort(from)} y ${dhFormatDateShort(to)}`;
}

function dhFormatDateLong(date) {
  const months = [
    "enero", "febrero", "marzo", "abril", "mayo", "junio",
    "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
  ];
  const d = date.getDate();
  const m = months[date.getMonth()];
  return `${d} de ${m}`;
}

function dhGetCutoffHour(root) {
  const n = Number(root.dataset.expressCutoffHour);
  return Number.isFinite(n) ? n : 12;
}

// Día base de cálculo (muy importante)
// - Si hoy NO es hábil => base = próximo hábil
// - Si hoy es hábil y hora >= cutoff => base = próximo hábil
// - Si hoy es hábil y hora < cutoff => base = hoy
function dhGetBaseBusinessDate(root) {
  const now = new Date();
  const cutoff = dhGetCutoffHour(root);
  const isBiz = dhIsBusinessDay(now);

  if (!isBiz) return dhStartOfDay(dhNextBusinessDay(dhStartOfDay(now)));

  const afterCutoff = now.getHours() >= cutoff;
  if (afterCutoff) return dhStartOfDay(dhNextBusinessDay(dhStartOfDay(now)));

  return dhStartOfDay(now);
}

async function dhLoadRegions() {
  if (!window.DH_REGIONS_JSON_URL) throw new Error("DH_REGIONS_JSON_URL no está definido");
  if (window.__DH_REGIONS_CACHE__) return window.__DH_REGIONS_CACHE__;

  const res = await fetch(window.DH_REGIONS_JSON_URL, { cache: "force-cache" });
  if (!res.ok) throw new Error("No se pudo cargar dh-regions-communes.json");
  window.__DH_REGIONS_CACHE__ = await res.json();
  return window.__DH_REGIONS_CACHE__;
}

async function dhLoadTransit() {
  if (!window.DH_TRANSIT_JSON_URL) return null;
  if (window.__DH_TRANSIT_CACHE__) return window.__DH_TRANSIT_CACHE__;

  const res = await fetch(window.DH_TRANSIT_JSON_URL, { cache: "force-cache" });
  if (!res.ok) return null;
  window.__DH_TRANSIT_CACHE__ = await res.json();
  return window.__DH_TRANSIT_CACHE__;
}

// Soporta:
// - number => {min,max} iguales
// - "3-5" o "3 – 5" => rango
// - {min:3,max:5}
function dhParseMinMax(value) {
  if (value === undefined || value === null) return null;

  if (typeof value === "number") {
    if (!Number.isFinite(value)) return null;
    const n = Math.max(0, value);
    return { min: n, max: n };
  }

  if (typeof value === "string") {
    const s = value.trim();
    if (!s) return null;

    // intenta "3-5"
    const m = s.match(/^(\d+(?:\.\d+)?)\s*[-–]\s*(\d+(?:\.\d+)?)$/);
    if (m) {
      const a = Number(m[1]);
      const b = Number(m[2]);
      if (Number.isFinite(a) && Number.isFinite(b)) {
        return { min: Math.max(0, Math.min(a, b)), max: Math.max(0, Math.max(a, b)) };
      }
    }

    // intenta número simple
    const n = Number(s);
    if (Number.isFinite(n)) {
      const nn = Math.max(0, n);
      return { min: nn, max: nn };
    }

    return null;
  }

  if (typeof value === "object") {
    const a = Number(value.min);
    const b = Number(value.max);
    if (Number.isFinite(a) && Number.isFinite(b)) {
      return { min: Math.max(0, Math.min(a, b)), max: Math.max(0, Math.max(a, b)) };
    }
    return null;
  }

  return null;
}

function dhGetTransitMinMax(transitData, regionName, communeName) {
  if (!transitData) return null;
  const byRegion = transitData?.[regionName];
  if (!byRegion) return null;

  const val = byRegion?.[communeName];
  if (val === undefined || val === null) return null;

  return dhParseMinMax(val);
}

function dhPopulateSelect(select, options, placeholder) {
  select.innerHTML = "";
  const ph = document.createElement("option");
  ph.value = "";
  ph.textContent = placeholder || "Selecciona";
  select.appendChild(ph);

  (options || []).forEach((opt) => {
    const o = document.createElement("option");
    o.value = opt;
    o.textContent = opt;
    select.appendChild(o);
  });
}

function dhSetActiveTab(root, tabName) {
  const tabStandard = root.querySelector('[data-dh-tab="standard"]');
  const tabExpress = root.querySelector('[data-dh-tab="express"]');
  const panels = root.querySelectorAll("[data-dh-panel]");

  // guarda estado actual
  root.dataset.dhActiveTab = tabName;

  [tabStandard, tabExpress].forEach(btn => {
    if (!btn) return;
    const isTarget = btn.getAttribute("data-dh-tab") === tabName;
    btn.classList.toggle("is-active", isTarget);
    btn.setAttribute("aria-selected", isTarget ? "true" : "false");
  });

  // Solo alterna los paneles standard/express.
  // Pickup queda fuera de estos panels, así que no se toca.
  panels.forEach(p => {
    const isTarget = p.getAttribute("data-dh-panel") === tabName;
    p.style.display = isTarget ? "block" : "none";
  });
}


function dhSetExpressUI(root, showTab, enabled) {
  const tabExpress = root.querySelector('[data-dh-tab="express"]');
  const hint = root.querySelector("[data-dh-express-hint], [data-dh-express-message]");

  if (!tabExpress) return;

  // Mostrar/ocultar tab Express (solo cuando corresponde)
  tabExpress.style.display = showTab ? "" : "none";

  // Habilitar/deshabilitar (difuminado)
  tabExpress.disabled = !enabled;

  // Nunca mostrar mensaje (para no confundir)
  if (hint) hint.style.display = "none";

  // Si está deshabilitado, forzar Estándar activo
  if (!enabled) dhSetActiveTab(root, "standard");
}


function dhSetPickupVisibility(root, show) {
  const pickup = root.querySelector("[data-dh-pickup-row], [data-dh-result-pickup]");
  if (pickup) pickup.style.display = show ? "block" : "none";
}

function dhWriteValue(root, selector, text) {
  const el = root.querySelector(selector);
  if (el) el.textContent = text;
}

// Siempre retorna rango tipo: "Llega entre Lun 19 y Mar 20" o "Llega Lun 19"
function dhComputeRangeLabelFromBase(baseDate, minDays, maxDays) {
  const minN = Math.max(0, Number(minDays) || 0);
  const maxN = Math.max(0, Number(maxDays) || 0);

  const from = dhAddBusinessDays(baseDate, minN);
  const to = dhAddBusinessDays(baseDate, maxN);

  if (minN === maxN) return `Llega ${dhFormatDateShort(from)}`;
  return `Llega entre ${dhFormatDateShort(from)} y ${dhFormatDateShort(to)}`;
}

// Express: hoy/mañana/fecha larga según textos del bloque
function dhComputeExpressLabel(root) {
  const textToday = root.dataset.expressTextToday || "Llega hoy";
  const textTomorrow = root.dataset.expressTextTomorrow || "Llega mañana";
  const textDateTpl = root.dataset.expressTextDate || "Llega el {fecha}";

  const now = new Date();
  const cutoff = dhGetCutoffHour(root);

  // Determinar deliveryDate (día hábil respetando cutoff)
  let deliveryDate;

  if (!dhIsBusinessDay(now)) {
    deliveryDate = dhStartOfDay(dhNextBusinessDay(dhStartOfDay(now)));
  } else if (now.getHours() < cutoff) {
    deliveryDate = dhStartOfDay(now);
  } else {
    deliveryDate = dhStartOfDay(dhNextBusinessDay(dhStartOfDay(now)));
  }

  const today = dhStartOfDay(now);

  // "Mañana" calendario (no hábil)
  const calendarTomorrow = dhStartOfDay(new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1));

  const isoDel = dhToISODate(deliveryDate);
  const isoToday = dhToISODate(today);
  const isoCalTomorrow = dhToISODate(calendarTomorrow);

  // Caso 1: llega hoy
  if (isoDel === isoToday) return textToday;

  // Caso 2: "Llega mañana" SOLO si el deliveryDate es literalmente mañana calendario
  // (y por construcción, si mañana NO es hábil, deliveryDate NO será mañana)
  if (isoDel === isoCalTomorrow) return textTomorrow;

  // Caso 3: cualquier otro caso => fecha larga (lunes, martes, etc.)
  const fechaLarga = dhFormatDateLong(deliveryDate);
  return textDateTpl.replace("{fecha}", fechaLarga);
}

function dhInitRoot(root, regionsData, transitData) {
  if (root.dataset.dhInit === "1") return;
  root.dataset.dhInit = "1";

  const rmRegionName = root.dataset.rmRegionName || "Metropolitana";
  const enableExpress = String(root.dataset.enableExpress) === "true";

  const expressCommunes = dhSplitCommaList(root.dataset.expressCommunes);
  const expressSet = new Set(expressCommunes.map(dhNormalize));
  const expressUnavailableMessage = root.dataset.expressUnavailableMessage || "";

  const pickupOnlyRM = String(root.dataset.pickupOnlyRm) === "true";

  const regionSelect = root.querySelector("[data-dh-region]");
  const communeSelect = root.querySelector("[data-dh-commune]");

  const regionPlaceholder = regionSelect?.querySelector("option")?.textContent || "Selecciona una región";
  const communePlaceholder = communeSelect?.querySelector("option")?.textContent || "Selecciona una comuna";

  // Poblar regiones
  const regions = Object.keys(regionsData || {});
  dhPopulateSelect(regionSelect, regions, regionPlaceholder);

  // UI initial
  dhSetActiveTab(root, "standard");
  dhSetExpressUI(root, false, false);
  dhSetPickupVisibility(root, false);

  function isRM(regionName) {
    return dhNormalize(regionName) === dhNormalize(rmRegionName);
  }

  function recalc(region, commune) {
  dhWriteValue(root, "[data-dh-standard-value]", "—");
  dhWriteValue(root, "[data-dh-express-value]", "—");
  dhWriteValue(root, "[data-dh-pickup-value]", "—");

  if (!region || !commune) return;

  const rm = isRM(region);
  const baseDate = dhGetBaseBusinessDate(root); // respeta cutoff + hábiles/feriados

  // =========================
  // STANDARD (rango siempre)
  // total = prep(min/max) + tránsito(min/max)
  // =========================
  const prepMin = Number(root.dataset.prepMinDays || 0);
  const prepMax = Number(root.dataset.prepMaxDays || 0);
  const prep = dhParseMinMax({ min: prepMin, max: prepMax }) || { min: 0, max: 0 };

  const transit = dhGetTransitMinMax(transitData, region, commune) || { min: 3, max: 3 };

  const stdMin = prep.min + transit.min;
  const stdMax = prep.max + transit.max;

  dhWriteValue(
    root,
    "[data-dh-standard-value]",
    dhComputeRangeLabelFromBase(baseDate, stdMin, stdMax)
  );

  // =========================
  // PICKUP (solo RM)
  // Usa pickup_min/max del bloque y etiqueta personalizable (Retira entre / Retira)
  // =========================
  const pickupVisible = rm && (!pickupOnlyRM || rm);
  dhSetPickupVisibility(root, pickupVisible);

  if (pickupVisible) {
    const pickMin = Number(root.dataset.pickupMinDays || 2);
    const pickMax = Number(root.dataset.pickupMaxDays || pickMin);
    const pick = dhParseMinMax({ min: pickMin, max: pickMax }) || { min: 2, max: 2 };

    const pickupResultLabel = root.dataset.pickupResultLabel || "Retira entre";
    const { rangePrefix, singlePrefix } = dhGetPickupPrefixes(pickupResultLabel);

    dhWriteValue(
      root,
      "[data-dh-pickup-value]",
      dhComputeRangeLabelFromBaseWithPrefixes(baseDate, pick.min, pick.max, rangePrefix, singlePrefix)
    );
  }

  // =========================
  // EXPRESS (solo RM + comunas habilitadas)
  // =========================
  if (enableExpress && rm) {
    const ok = expressSet.has(dhNormalize(commune));
    dhSetExpressUI(root, true, ok);

    if (ok) {
      dhWriteValue(root, "[data-dh-express-value]", dhComputeExpressLabel(root));
    } else {
      dhWriteValue(root, "[data-dh-express-value]", "—");
    }
  } else {
    dhSetExpressUI(root, false, false);
  }
}

  // Mantener coherencia UI: si el usuario estaba en Express y ahora no aplica, volvemos a Standard
  const active = root.dataset.dhActiveTab || "standard";
  if (active === "express") {
    const tabExpressBtn = root.querySelector('[data-dh-tab="express"]');
    if (!tabExpressBtn || tabExpressBtn.disabled || tabExpressBtn.style.display === "none") {
      dhSetActiveTab(root, "standard");
    }
  } else {
    // si está en standard, nos aseguramos que se vea standard
    dhSetActiveTab(root, "standard");
  }

  regionSelect?.addEventListener("change", () => {
    const region = regionSelect.value;

    communeSelect.disabled = !region;
    if (!region) {
      dhPopulateSelect(communeSelect, [], communePlaceholder);
      dhSetExpressUI(root, false, false);
      dhSetPickupVisibility(root, false);
      recalc(null, null);
      return;
    }

    const communes = regionsData[region] || [];
    dhPopulateSelect(communeSelect, communes, communePlaceholder);

    dhSetActiveTab(root, "standard");
    dhSetPickupVisibility(root, false);

    // Si es RM, mostramos tab express (pero deshabilitado hasta elegir comuna)
    dhSetExpressUI(root, isRM(region) && enableExpress, false, "");
    recalc(region, null);
  });

  communeSelect?.addEventListener("change", () => {
    const region = regionSelect.value;
    const commune = communeSelect.value;

    dhSetActiveTab(root, "standard");
    recalc(region, commune);
  });

  root.addEventListener("click", (e) => {
    const btn = e.target.closest(".dh-tab");
    if (!btn) return;
    if (btn.disabled) return;

    const tab = btn.getAttribute("data-dh-tab");
    if (!tab) return;
    dhSetActiveTab(root, tab);
  });
}

async function dhBoot() {
  const roots = document.querySelectorAll("[data-dh-estimator]");
  if (!roots.length) return;

  try {
    const [regionsData, transitData] = await Promise.all([dhLoadRegions(), dhLoadTransit()]);
    roots.forEach((root) => dhInitRoot(root, regionsData, transitData));
  } catch (err) {
    console.warn("[DH Estimator] Error:", err);
  }
}

document.addEventListener("DOMContentLoaded", dhBoot);
